import { minutesFromTop } from './week';

/** Roughly how tall a chip is, in minutes (1px per minute): its slot is taken. */
export const CHIP_MINUTES = 70;

/**
 * Side-by-side lanes for posts whose chips would overlap: posts are grouped
 * into clusters that overlap in time, and each takes the first free lane.
 */
export function layoutLanes(
  posts: { id: string; start: Date }[],
): Map<string, { lane: number; lanes: number }> {
  const sorted = [...posts].sort((a, b) => a.start.getTime() - b.start.getTime());
  const result = new Map<string, { lane: number; lanes: number }>();
  let cluster: { id: string; lane: number }[] = [];
  let laneEnds: number[] = [];
  let clusterEnd = -Infinity;
  const close = () => {
    for (const { id, lane } of cluster) result.set(id, { lane, lanes: laneEnds.length });
    cluster = [];
    laneEnds = [];
  };
  for (const post of sorted) {
    const start = minutesFromTop(post.start);
    if (start >= clusterEnd) close();
    let lane = laneEnds.findIndex((end) => end <= start);
    if (lane === -1) lane = laneEnds.length;
    laneEnds[lane] = start + CHIP_MINUTES;
    clusterEnd = Math.max(clusterEnd, start + CHIP_MINUTES);
    cluster.push({ id: post.id, lane });
  }
  close();
  return result;
}
